
export interface IAudioPlayerState {
    audioUrl?: string;
    title?: string;
	isShow?: boolean;
	recordId?: number;
	isPlaying?: boolean;
}

export const AUDIO_PLAYER_STORE_TYPES = {
	SET_AUDIO_URL: 'setAudioUrl',
	SET_TITLE: 'setTitle',
	SET_IS_SHOW: 'setIsShow',
	SET_AUDIO_PLAYER: 'setAudioPlayer',
	SET_RECORD_ID: 'setRecordId',
	SET_IS_PLAYING: 'setIsPlaying'
}